module.exports = __webpack_public_path__ + "img/value-hero2.905b47ae.jpg";